import CloseIcon from '@mui/icons-material/Close';
import ErrorIcon from '@mui/icons-material/Error';
import { ReactElement, ReactNode } from 'react';

import { ReactComponent as CheckIcon } from 'assets/icons/check.svg';

import {
  AlertContent,
  AlertContentW,
  AlertIconW,
  AlertMessage,
  AlertW,
  CloseButton,
} from './styled';

export interface AlertProps {
  children: ReactNode;
  variant?: 'info' | 'success' | 'danger';
  close?(): void;
  withIcon?: boolean;
}

function getAlertIcon(variant?: AlertProps['variant']) {
  switch (variant) {
    case 'success':
      return <CheckIcon color="primary" />;
    case 'info':
      return <CheckIcon />;
    default:
      return <ErrorIcon />;
  }
}

export function Alert({
  children,
  close,
  variant = 'info',
  withIcon = true,
}: AlertProps): ReactElement {
  const newDesign = false;
  return (
    <AlertW variant={variant} aria-label={`alert ${variant}`}>
      {withIcon && <AlertIconW>{getAlertIcon(variant)}</AlertIconW>}

      <AlertContentW>
        <AlertContent>
          <AlertMessage>{children}</AlertMessage>
        </AlertContent>
      </AlertContentW>

      {close && newDesign && (
        <CloseButton type="button" aria-label="Close" onClick={close} sx={{ padding: 0 }}>
          <CloseIcon />
        </CloseButton>
      )}
    </AlertW>
  );
}
